import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, FadeUp } from "../components/Reveal";
import { api, asList } from "../lib/api";
import ShareFragment from "../components/ShareFragment";
import useSeo from "../lib/useSeo";

const fmtDay = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function Fragments() {
  useSeo("Fragments", "Every fragment of the day from Outlaw Creative: one saying, cut from that day's headlines.");
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/fragment/archive").then((r) => setItems(asList(r))).catch(() => setItems([])); }, []);

  return (
    <section className="px-5 sm:px-8 lg:px-12 pt-32 pb-24" data-testid="fragments-page">
      <header className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20">
        <div className="lg:col-span-8">
          <p className="eyebrow mb-5">&sect; The daily record</p>
          <h1 className="f-display font-black uppercase text-[18vw] sm:text-[13vw] lg:text-[9.5vw] leading-[0.82]">
            <MaskLines onMount lines={["Frag", <span key="m" className="outline-text">ments</span>]} />
          </h1>
        </div>
        <p className="lg:col-span-4 self-end f-serif italic text-xl sm:text-2xl text-[#cfcec8]">One saying a day, cut from that morning&rsquo;s headlines. Scroll back through the year.</p>
      </header>
      <ol className="border-t border-[var(--bone)]" data-testid="fragments-list">
        {(items || []).map((f, i) => (
          <FadeUp as="li" key={f.day} delay={Math.min(i, 6) * 0.05} className="border-b border-[var(--line)] py-10 grid grid-cols-1 md:grid-cols-12 gap-4" data-testid={`fragment-${f.day}`}>
            <div className="md:col-span-3 flex md:flex-col gap-3 items-baseline">
              <span className="f-mono text-xs text-[var(--ash)]">No. {String((items?.length || 0) - i).padStart(3, "0")}</span>
              <span className="f-mono text-xs text-[var(--bone)]">{fmtDay(f.day)}</span>
            </div>
            <div className="md:col-span-9">
              <p className="f-serif italic font-light text-2xl sm:text-4xl leading-[1.15]">{f.fragment}</p>
              {f.headline && (
                <p className="mt-5 f-mono text-[11px] text-[var(--ash)] flex flex-wrap items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--signal)]" /> {f.headline}
                  {f.source?.url && <a href={f.source.url} target="_blank" rel="noopener noreferrer" className="link-u text-[var(--bone)] inline-flex items-center gap-1">source <ArrowUpRight size={11} /></a>}
                </p>
              )}
              <ShareFragment fragment={f} className="mt-5 text-[#cfcec8]" />
            </div>
          </FadeUp>
        ))}
        {items && !items.length && <li className="py-10 f-serif italic text-[#bdbcb5]">The first fragment is still being cut.</li>}
      </ol>
      <p className="f-mono text-[11px] text-[var(--ash)] mt-8">AI-written from each day&rsquo;s news via Perplexity</p>
    </section>
  );
}
